import {Form, Input, message, Upload, UploadFile} from "antd";
import React from "react";
import {CategoryDTO} from "../../../types/category/CategoryDTO";
import {CategoryCreateDTO} from "../../../types/category/CategoryCreateDTO";
import {UploadOutlined} from "@ant-design/icons";
import {useGetAuthToken} from "../../../store/api/AuthSlice";

const {Dragger} = Upload

interface CategoryCreateFormProps {
    category: CategoryDTO | undefined
    onFinish: (data: CategoryCreateDTO) => void
}

const CategoryCreateForm: React.FC<CategoryCreateFormProps> = ({category, onFinish}) => {
    const [form] = Form.useForm()
    const token = useGetAuthToken()

    const onFinishHandler = async (values: any) => {
        const dto: CategoryCreateDTO = {
            name: values.name === category?.name ? null : values.name.trim(),
            picture_url: values.picture_url === category?.picture_url ? null : values.picture_url.file.response.data
        }
        onFinish(dto)
    }

    const beforeUpload = (file: UploadFile) => {
        const isLt2M = file.size! < 2e6
        if (!isLt2M) {
            message.error("Размер изображения должен быть меньше 2 МБ")
        }
        return isLt2M || Upload.LIST_IGNORE;
    }

    return (
        <Form form={form} onFinish={onFinishHandler} id={'category-create-form'} layout="vertical"
              initialValues={{
                  name: category?.name,
                  picture_url: category?.picture_url
              }}>
            <Form.Item
                name="name"
                label="Название"
                rules={[{required: true, whitespace: true, message: "Введите название"}]}
            >
                <Input placeholder={'Введите название'}/>
            </Form.Item>
            <Form.Item
                name="picture_url"
                label={<div>Фото <span style={{fontSize: '10px'}}>(Ширина - 390px, Высота - 844px. Разрешение файлов изображений: JPG, PNG)</span></div>}
                rules={[{required: true, message: "Загружите фото"}]}
            >
                <Dragger accept={"image/png, image/jpeg"} listType={'picture'} maxCount={1}
                         action={`${process.env.REACT_APP_BASE_URL}/attachments/upload`}
                         headers={{Authorization: `Bearer ${token}`}}
                         defaultFileList={category && [{
                             uid: `${category.id}`,
                             name: `${category.picture_url.substring(category.picture_url.lastIndexOf('/') + 1)}`,
                             url: `${category.picture_url}`
                         }]} beforeUpload={beforeUpload}
                         showUploadList={{showPreviewIcon: false, showRemoveIcon: false, showDownloadIcon: false}}>
                    <UploadOutlined/>
                    <p className="ant-upload-text">Нажмите или перетащите фото для загрузки</p>
                </Dragger>
            </Form.Item>
        </Form>
    )
}

export default CategoryCreateForm